import React from 'react';
import ReactDOM from 'react-dom';
import { MicroApp, peerDependencies } from '@gcc/autobahn-micro-app';
import * as styled from 'styled-components';

// Expose micro app peer dependencies.
peerDependencies(React, ReactDOM, styled);

const {
  pageModel: {
    microConfig = {
      View: {
        // Fall back config
        Name: 'product-preview',
        Version: 'latest',
      },
    },
  } = {},
} = window.pageContextJavascript;

// microConfig.View.Path = `http://localhost:3001/marketplace/${microConfig.View.Name}/${microConfig.View.Name}.${microConfig.View.Version}.js`;

const App = () => <MicroApp config={microConfig} />;

export default App;
